<script setup>
const props = defineProps({
  disabled: {
    type: Boolean,
    default: false,
  },
  owner: {
    type: Object,
    required: true,
  },
  tag: {
    type: String,
  },
});
</script>

<template>
  <div :class="[$style.user, props.disabled && $style['user--disabled']]">
    <div v-if="props.tag" :class="$style.user__tag">{{ props.tag }}</div>
    <div :class="$style.user__details">
      <div :class="$style.user__name">
        {{ props.owner.fullName }}
      </div>
      <div :class="$style.user__email">{{ props.owner.email }}</div>
    </div>
  </div>
</template>

<style lang="less" module>
.user {
  position: relative;
  border: 1px solid #5b00f0;
  text-align: left;
  padding: 16px;
  display: flex;
  align-items: center;
  color: #303032;
  font-size: 14px;
  line-height: 1.4;
}

.user--disabled {
  border-color: #e8e8ea;
}

.user__tag {
  position: absolute;
  top: -16px;
  left: 4px;
  padding: 6px 8px;
  background: #000;
  color: #fff;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  line-height: 1;
}

.user__details {
  display: inline-block;
  .user__name {
    font-weight: bold;
  }
  .user__email {
    margin-right: 2px;
  }
}
</style>
